import { render, staticRenderFns } from "./AuxItems.vue?vue&type=template&id=e2f7c9fc&scoped=true"
import script from "./AuxItems.vue?vue&type=script&lang=ts"
export * from "./AuxItems.vue?vue&type=script&lang=ts"
import style0 from "./AuxItems.vue?vue&type=style&index=0&id=e2f7c9fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f7c9fc",
  null
  
)

export default component.exports